import type { CalcResult } from '../hooks/useCalculatorLogic'

export function selectCalculationRoute(result: CalcResult | null, index: number): CalcResult | null {
  const alternative = result?.alternatives?.[index - 1]
  return alternative ? { ...result, ...alternative } : result
}

export function sharedRouteSegments(result: CalcResult | null) {
  const shared = new Set(result?.shared_edge_ids ?? [])
  return (result?.route_segments ?? []).filter(segment => segment.kind === 'pathway' && shared.has(segment.edge_id ?? ''))
}
